import React, { useState } from "react";
import "./Profile.css";
import DashboardHeader from "../../../Components/header/DashboardHeader";
import profile_detail from "../../../assets/icons/user.png";
import cnt_account from "../../../assets/icons/dollar.png";
import trn_history from "../../../assets/icons/Frame.png";
import category from "../../../assets/icons/Widget 2.png";
import desi_connect from "../../../assets/icons/Danger Circle.png";
import faq from "../../../assets/icons/faq.png";
import help_support from "../../../assets/icons/help.png";
import security from "../../../assets/icons/security-safe.png";
import term_condition from "../../../assets/icons/Document.png";
import { useNavigate } from "react-router";
import PersonalDetails from "./section/PersonalDetails";
import TransactionHistory from "./section/TransactionHistory";
import InterestedCategories from "./section/InterestedCategories";
import Desi_connect from "./section/Desi_connect";
import FAQ from "./section/FAQ";
import Help_Support from "./section/Help_Support";
import Privacy from "./section/Privacy";
import Terms from "./section/Terms";
import { useSearchParams } from "react-router-dom";
import ConnectMeet from "./section/ConnectMeet";
import { subscription_icon } from "../../../assets";
import SubscriptionHIstory from "./section/subscriptionHistory/SubscriptionHIstory";
import { GiHamburgerMenu } from "react-icons/gi";
import { RxCrossCircled } from "react-icons/rx";

const Profile = () => {
  const[sideMenu,setSideMenu]=useState(false)
  const navigate = useNavigate();
  const [searchParam, setSearchParam] = useSearchParams();
  const tab = searchParam.get("tab") || "profileDetails";

  const tabHandler = (tab) => {
    searchParam.set("tab", tab);
    setSearchParam(searchParam);
  };

  return (
    <>
      <DashboardHeader />
      <div className={`dashbaord_card ${sideMenu ? "show":""}`}>
        <div className="profile_section">
          <div className="profileNav">

          <button className="personal-info_crossbtn" onClick={()=>setSideMenu(!sideMenu)}>
              <RxCrossCircled className="crossbtn" />
            </button>

            <ul>
              <li
                className={tab === "profileDetails" ? "active" : ""}
                onClick={() => tabHandler("profileDetails")}
              >
                <img src={profile_detail} />
                <span>Profile Details</span>
              </li>
              <li
                className={tab === "cnnectAccount" ? "active" : ""}
                onClick={() => tabHandler("cnnectAccount")}
              >
                <img src={cnt_account} />
                <span>Connect Account</span>
              </li>

              <li
                className={tab === "transactionHistory" ? "active" : ""}
                onClick={() => tabHandler("transactionHistory")}
              >
                <img src={trn_history} />
                <span>Transaction history</span>
              </li>

              <li
                className={tab === "subscriptionHistory" ? "active" : ""}
                onClick={() => tabHandler("subscriptionHistory")}
              >
                <img src={subscription_icon} />
                <span>Subscription history</span>
              </li>

              <li
                className={tab === "Categories" ? "active" : ""}
                onClick={() => tabHandler("Categories")}
              >
                <img src={category} />
                <span>Interested Categories</span>
              </li>
              <li
                className={tab === "Meet" ? "active" : ""}
                onClick={() => tabHandler("Meet")}
              >
                <img src={desi_connect} />
                <span>Connect Google</span>
              </li>
              <li
                className={tab === "About" ? "active" : ""}
                onClick={() => tabHandler("About")}
              >
                <img src={desi_connect} />
                <span>About Logical Chat</span>
              </li>
              <li
                className={tab === "faq" ? "active" : ""}
                onClick={() => tabHandler("faq")}
              >
                <img src={faq} />
                <span>FAQ's</span>
              </li>
              <li
                className={tab === "support" ? "active" : ""}
                onClick={() => tabHandler("support")}
              >
                <img src={help_support} />
                <span>Help & Support</span>
              </li>
              <li
                className={tab === "privacyPolicy" ? "active" : ""}
                onClick={() => tabHandler("privacyPolicy")}
              >
                <img src={security} />
                <span>Privacy Policy</span>
              </li>
              <li
                className={tab === "termsConditions" ? "active" : ""}
                onClick={() => tabHandler("termsConditions")}
              >
                <img src={term_condition} />
                <span>Terms and Conditions</span>
              </li>
            </ul>

          </div>

          <div className="profile_content">

            
          <button className="personal_menubtn" onClick={()=>setSideMenu(!sideMenu)}>
              <GiHamburgerMenu className="personal-info_menu" />
           </button>

            {tab === "profileDetails" && <PersonalDetails />}
            {tab === "transactionHistory" && <TransactionHistory />}
            {tab === "subscriptionHistory" && <SubscriptionHIstory />}
            {tab === "Categories" && <InterestedCategories />}
            {tab === "About" && <Desi_connect />}
            {tab === "faq" && <FAQ />}
            {tab === "support" && <Help_Support />}
            {tab === "privacyPolicy" && <Privacy />}
            {tab === "termsConditions" && <Terms />}
            {tab === "Meet" && <ConnectMeet />}
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
